import { idGenerator } from '@/services'

export interface ProsumerBonusState {
  requestId: string
}

export const InitialState: ProsumerBonusState = {
  requestId: idGenerator.getNewWebReference()
}
